import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Page } from '../models/page-wrapper.model';
import { ClaimContract } from './claim-contract.model';

@Injectable({
  providedIn: 'root',
})
export class ClaimContractService {
  private apiUrl = `${environment.restApiUrl}claimContracts`;

  constructor(private http: HttpClient) {}

  createClaimContract(claimContract: Partial<ClaimContract>): Observable<ClaimContract> {
    return this.http.post<ClaimContract>(this.apiUrl + '/create', claimContract);
  }

  searchClaimContracts(params: HttpParams): Observable<Page<ClaimContract>> {
    return this.http.get<Page<ClaimContract>>(this.apiUrl + '/search', { params });
  }

  getClaimContractById(id: number): Observable<ClaimContract> {
    return this.http.get<ClaimContract>(`${this.apiUrl}/${id}`);
  }

  updateClaimContract(
    id: number,
    claimContract: Partial<ClaimContract>
  ): Observable<ClaimContract> {
    return this.http.put<ClaimContract>(`${this.apiUrl}/${id}`, claimContract);
  }

  deleteClaimContract(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  updateClaimContractStatus(
    id: number,
    workflowStatusId: number,
    updatedByUserId: number
  ): Observable<ClaimContract> {    
    const params = new HttpParams()
      .set('workflowStatusId', workflowStatusId.toString())
      .set('updatedByUserId', updatedByUserId.toString());
    return this.http.patch<ClaimContract>(`${this.apiUrl}/${id}/status`, null, {
      params,
    });
  }
  
  getAttachmentViewUrl(claimContractId: number, attachmentId: number): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${this.apiUrl}/${claimContractId}/attachments/${attachmentId}/view-url`);
  }
}
